import { usePlatformTagUsage, usePlatformTags } from '../../queries';
import { usageByTag } from '../../tags/usage';
import { PlatformTagsPanel } from '../PlatformTagsPanel';
import { AreaGate } from './AreaGate';

/**
 * The panel reports how many tournaments carry each tag. The server counts them, every room included (known gap 92);
 * the count is not stored on the tag.
 */
export function TagsArea() {
  const tags = usePlatformTags();
  const usage = usePlatformTagUsage();

  return (
    <AreaGate
      queries={[tags, usage]}
      loadingLabel="Loading tags…"
      errorMessage="Couldn't load the platform tags."
    >
      <PlatformTagsPanel tags={tags.data ?? []} usage={usageByTag(usage.data)} />
    </AreaGate>
  );
}
